require("./bootstrap"); //eslint-disable-line

require("@coreui/coreui"); //eslint-disable-line

//custom Propreties for IE 11
(function () {
  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(
      event,
      params.bubbles,
      params.cancelable,
      params.detail
    );
    return evt;
  }
  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
  Math.sign = function sign(x) {
    return !(x = parseFloat(x)) ? x : x > 0 ? 1 : -1;
  };
})();
//end of Propreties for IE 11

console.log("da");



// WEBPACK FOOTER //
// ./resources/js/app.js